import nextStep from 'utils/loginAuthnTree/handleStep';
import {
  AuthTreeMessages,
  DOB_LASTNAME_NOT_FOUND,
  DOB_LASTNAME_NOT_FOUND_LEGACY,
  G200_ERROR,
  D619_ERROR,
  D704_ERROR,
} from 'components/ForgotPassword/constants';
import { updateFPErrorAction } from 'components/ForgotPassword/actions';
import removeSessionStorageAttributes from 'utils/removeSessionStorageAttributes';
import { CallbackType, StepType } from '@forgerock/javascript-sdk';
import { updateErrorInState } from 'ciam-self-service-shared';
import { checkStep } from 'utils/authTree/helpers';
import { getCallbackOfTypeSafely, getCallbackWithMessageSafely, getCallbackWithPromptSafely } from '../authTreeUtils';
import { updateErrorCode } from 'components/Login/actions';

const CONFIRMATION_INPUT_VALUE = 0;

const handleFinalResponse = async (dispatch, finalStep, history) => {
  const lastNameNotFoundCallback =
    getCallbackWithMessageSafely(finalStep, DOB_LASTNAME_NOT_FOUND) ||
    getCallbackWithMessageSafely(finalStep, DOB_LASTNAME_NOT_FOUND_LEGACY);
  const passwordCallback = getCallbackOfTypeSafely(finalStep, CallbackType.PasswordCallback);

  if (lastNameNotFoundCallback) {
    updateErrorInState(dispatch, D619_ERROR, updateFPErrorAction);
  } else if (passwordCallback) {
    history.push('/inputpassword');
  } else {
    // handle any unkown callbacks or errors
    updateErrorInState(dispatch, G200_ERROR, updateErrorCode);
    history.push('/');
  }
};

const userInfoAsyncAction = async (dispatch, payload) => {
  await removeSessionStorageAttributes();
  const { lastName, dob, stage, history } = payload;
  const lastNameCallback = getCallbackWithPromptSafely(stage, AuthTreeMessages.LastName);
  const dobCallback = getCallbackWithPromptSafely(stage, AuthTreeMessages.DateOfBirth);

  if (lastNameCallback && dobCallback) {
    lastNameCallback.setName(lastName);
    dobCallback.setName(dob);
    const finalStep = await nextStep(dispatch, stage);
    await handleFinalResponse(dispatch, finalStep, history);
  } else if (
    getCallbackWithMessageSafely(stage, DOB_LASTNAME_NOT_FOUND) ||
    getCallbackWithMessageSafely(stage, DOB_LASTNAME_NOT_FOUND_LEGACY)
  ) {
    const confirmationCallback = stage.getCallbackOfType(CallbackType.ConfirmationCallback);
    if (confirmationCallback) {
      confirmationCallback.setInputValue(CONFIRMATION_INPUT_VALUE);
    } else {
      // Missing ConfirmationCallback in the authentication flow.
      checkStep(null, D704_ERROR);
      return;
    }

    const secondStep = await nextStep(dispatch, stage);
    const nextStepLastNameCallback = getCallbackWithPromptSafely(secondStep, AuthTreeMessages.LastName);
    const nextStepDobCallback = getCallbackWithPromptSafely(secondStep, AuthTreeMessages.DateOfBirth);

    if (nextStepLastNameCallback && nextStepDobCallback) {
      nextStepLastNameCallback.setName(lastName);
      nextStepDobCallback.setName(dob);
      const resultStep = await nextStep(dispatch, secondStep);
      await handleFinalResponse(dispatch, resultStep, history);
    } else if (secondStep.type === StepType.LoginFailure) {
      checkStep(null, D704_ERROR);
      return;
    }
  } else {
    // handle any uncaught error - request not sent from UI
    checkStep(null, D704_ERROR);
  }
};

export default userInfoAsyncAction;
